/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useState, useEffect } from "react";
import { Container } from "@material-ui/core";
import PageTitle from "../../components/pageTitle/PageTitle";
import ThemeTable from "../../components/Table/ThemeTable";
import CommonContext from "../../hooks/commonContext";
import { FormatedDates } from "../../services/helpers";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { Columns } from "./NotificationTableColumns";
import NotificationDetails from "./NotificationDetails";
import { getNotificationList } from "../../services/apiservices/notifications";
import AuthContext from "../../hooks/authContext";
import { getEmployeesList } from "../../services/apiservices/employee";
import { useMediaQuery } from "@mui/material";
import styles from "./notification.module.scss";
import moment from "moment";
import { useNavigate } from "react-router";
import { Badge } from "../../components/ui/badge";
import { Button } from "../../components/ui/button";
import { Eye, Plus, Search, User } from "lucide-react";
import { Input } from "../../components/ui/input";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "../../components/ui/dialog";

function Notification(props) {
  const commonContext = useContext(CommonContext);
  const [allNotifications, setAllNotifications] = useState([]);
  const [isLoading, setIsLoading] = React.useState(false);
  const [openDialog, setOpenDialog] = React.useState(false);
  const [names, setNames] = React.useState();
  const [searchTerm, setsearchTerm] = React.useState("");
  const [isOpen, setIsOpen] = React.useState(false);
  const [data, setData] = useState();
  const isMobile = useMediaQuery("(max-width:767px)");
  const auth = useContext(AuthContext);
  const navigate = useNavigate();
  const localClientID = localStorage.getItem('clientId');
  const localCompanyId = localStorage.getItem('companyId');
  const companyId = auth?.userProfile?.role === "Client" ? localCompanyId ? localCompanyId : auth?.userProfile?.companyId : auth?.userProfile?.role === "companyUser" ? auth?.userProfile?.id : auth?.userProfile?.companyId;
  const clientId = localClientID ? localClientID : auth?.userProfile?.client;

  const fetchNotificationList = async () => {
    setIsLoading(true);
    getEmployeesList({}, async (res) => {
      const filteredEmployees = res?.filter((employee) =>
        employee?.clients?.some((client) => client?.clientid === clientId)
      );
      const employeeIds = filteredEmployees.map((emp) => emp?.id);
      const validUserIds = [clientId, ...employeeIds];
      await getNotificationList(
        async (res) => {
          if (res) {
            const data = res?.filter(
              (item) =>
                item.companyId === companyId &&
                (auth?.userProfile?.role !== "Client" ||
                  (Array.isArray(item?.Client) &&
                    item?.Client.some((client) => client?.id === clientId)) ||
                  (Array.isArray(item?.Employee) &&
                    item?.Employee.some((emp) =>
                      validUserIds.includes(emp.id)
                    )))
            );
            let datares = data.map((ritem) => {
              let groupobj = ritem.Group;
              var valyt;
              for (const key in groupobj) {
                if (key === "title") {
                  valyt = groupobj[key];
                }
              }

              return { ...ritem, group: valyt };
            });
            datares.sort((a, b) => {
              return new Date(b.createdOn) - new Date(a.createdOn);
            });
            setAllNotifications(datares);
            setIsLoading(false);
          } else {
            setIsLoading(false);
          }
        },
        (resError) => {
          console.log("reserror", resError);
          setIsLoading(false);
        }
      );
    });
  };
  useEffect(() => {
    fetchNotificationList();
  }, []);

  const handleClose = () => {
    setIsOpen(false);
    setData();
  };
  const handleOnClose = () => {
    setOpenDialog(false);
    setNames();
  };

  const MethodBadges = ({ methods }) => {
    let normalized = [];

    if (Array.isArray(methods)) {
      normalized = methods;
    } else if (methods === "Both") {
      normalized = ["Email", "Push", "SMS"];
    } else if (methods === "PushNotification") {
      normalized = ["Push"];
    } else if (methods) {
      normalized = [methods];
    }

    const allTypes = ["Email", "Push", "SMS"];
    const hasAll = allTypes.every((type) => normalized.includes(type));

    if (hasAll) {
      return (
        <Badge
          variant="info"
          className="whitespace-nowrap"
          style={{ borderRadius: "6px" }}
        >
          ALL
        </Badge>
      );
    }

    return (
      <div
        className={`flex flex-wrap gap-1 ${isMobile ? "max-w-[180px]" : ""}`}
      >
        {normalized?.map((method, index) => {
          let label = method;
          let variant = "info";

          if (method === "PushNotification"){
            label = "PushNotification";
            variant = "success";
          } else if (method === "Push") {
            label = "SMS";
            variant = "warning";
          } else if (method === "Email") {
            variant = "info";
          } else if (method === "SMS") {
            variant = "warning";
          }

          return (
            <Badge
              key={index}
              variant={variant}
              className="mr-4 last:mr-0"
              style={{ borderRadius: "6px" }}
            >
              {label}
            </Badge>
          );
        })}
      </div>
    );
  };

  const renderRowCell = (rcellItem, hcellItem, index, rowindex) => {
    switch (hcellItem.id) {
      case "createdOn":
        return (
          <div
            className="notifWidth1"
            style={{ fontSize: "14px", fontWeight: "500" }}
          >
            {FormatedDates(rcellItem?.createdOn)}
          </div>
        );
      case "recipient":
        let recipientLabel = "";
        let recipientCount = 0;
        let recipientData = null;

        if (rcellItem.Employee && rcellItem.Employee.length > 0) {
          recipientLabel = "Name";
          recipientCount = rcellItem.Employee.length;
          recipientData = rcellItem.Employee;
        } else if (
          rcellItem.Client &&
          Object.keys(rcellItem.Client).length > 0
        ) {
          recipientLabel = "Client";
          recipientCount = 1;
          recipientData = [rcellItem.Client];
        } else if (rcellItem.Group && Object.keys(rcellItem.Group).length > 0) {
          recipientLabel = "Group";
          recipientCount = 1;
          recipientData = [rcellItem.Group];
        }

        return (
          <div className="d-flex flex-center">
            <span className="mr-3">
              {recipientLabel}
            </span>
            <span
              style={{ color: "blue" }}
              onClick={() => {
                setOpenDialog(true);
                setNames(recipientData);
              }}
            >
              ({recipientCount})
            </span>
          </div>
        );
      case "Type":
        return <MethodBadges methods={rcellItem?.Type} />;
      case "Message":
        return (
          <div className="d-flex flex-direction-column">
            <div
              style={{
                color: "#4B5563",
                fontWeight: "700",
                lineHeight: "24px",
                fontSize: "14px",
                marginBottom: "6px",
              }}
            >
              {" "}
              {rcellItem?.subject ? rcellItem?.subject : ""}
            </div>
            <div style={{fontSize: "14px" }}>
              {" "}
              {rcellItem?.Message?.length > 30
                ? rcellItem.Message.substring(0, 30) + "..."
                : rcellItem?.Message}
            </div>
          </div>
        );
      case "action":
        return (
          <>
            <div
              onClick={() => {
                setData(rcellItem);
                setIsOpen(true);
              }}
            >
              {" "}
              <VisibilityOutlinedIcon
                fontSize="small"
                className="dark:text-white text-black"
              />
            </div>
          </>
        );

      default:
        return rcellItem[hcellItem?.id];
    }
  };

  const checkRowSearch = (searchTerm, row) => {
    return (
      String(row.subject)
        .toLowerCase()
        .includes(String(searchTerm).toLowerCase()) ||
      String(row.Message)
        .toLowerCase()
        .includes(String(searchTerm).toLowerCase()) ||
      String(row.Type).toLowerCase().includes(String(searchTerm).toLowerCase())
    );
  };

  const filteredList = allNotifications?.filter((item) => {
    const matchesSearch =
      searchTerm !== "" ? checkRowSearch(searchTerm, item) : true;
    return matchesSearch;
  });

  const handleNavigate = () => {
    navigate("/communications/notifications/create");
  };

  return (
    <>
      <Container>
        <PageTitle
          pageTitle="Manage Notification"
          showBreadcrumb={[
            { label: "Home", to: "/" },
            { label: "Communications" },
          ]}
          BreadCrumbCurrentPageTitle={"Notifications"}
          showLastSeen={true}
          buttonTitle="New Notifications"
          icons={<Plus className="h-4 w-4 mr-5" />}
          buttonClass={"d-flex flex-center"}
          buttonStyle={{
            color: "white",
            backgroundColor: "#16A34A",
            padding: "8px 16px",
            borderRadius: "5px",
          }}
          buttonClick={() => handleNavigate()}
        />

        <div style={{ padding: isMobile ? "20px 15px" : "24px 32px" }}>
             <div
              className={
                isMobile
                  ? "d-flex flex-direction-column pv-15 ph-12"
                  : "d-flex flex-space-between flex-center mv-20"
              }
            >
              <div>
                <div
                className="text-foreground"
                  style={{
                    fontSize: "24px",
                    fontWeight: "700",
                  }}
                >
                  Notification Management
                </div>
                <div
                  className="mv-10"
                  style={{ fontSize: "16px", color: "#6B7280" }}
                >
                  View previous notifications sent to your team
                </div>
              </div>
            </div>
             <div
              className={isMobile ? "ph-10 shadow-md dark:bg-[#1A1F2C] dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]" : `sectionBox2 shadow-md dark:bg-[#1A1F2C] dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]`}
              style={{
                // borderRadius: "8px",
                // border: "1px solid hsl(214.3, 31.8%, 91.4%)",
              }}
            >
          <div className="flex items-center w-full max-w-md mb-8">
            <div className="relative flex-1 mt-8">
              <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-gray-500" />
              <Input
                type="search"
                placeholder="Search notifications..."
                value={searchTerm}
                onChange={(e) => setsearchTerm(e.target.value)}
                className="pl-32"
              />
            </div>
          </div>
            {!isMobile && (
              <ThemeTable
                rows={filteredList}
                headCells={Columns}
                hidePagination={false}
                isLoading={isLoading}
                renderRowCell={renderRowCell}
              />
            )}

            {isMobile &&
              filteredList?.map((item, index) => {
                let recipientLabel = "";
                let recipientCount = 0;
                let recipientData = null;

                if (item.Employee && item.Employee.length > 0) {
                  recipientLabel = "Name";
                  recipientCount = item.Employee.length;
                  recipientData = item.Employee;
                } else if (item.Client && Object.keys(item.Client).length > 0) {
                  recipientLabel = "Client";
                  recipientCount = 1;
                  recipientData = [item.Client];
                } else if (item.Group && Object.keys(item.Group).length > 0) {
                  recipientLabel = "Group";
                  recipientCount = 1;
                  recipientData = [item.Group];
                }
                const formattedTime = moment
                  .utc(item?.createdOn)
                  .format("hh:mm A");

                return (
                  <div key={index} className={`${styles.card} dark:bg-[#1A1F2C] dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] dark:border-0`}>
                    <div className={styles.cardContent}>
                      <div className={styles.cardHeader}>
                        <div className={styles.cardDate}>
                          <span className="dark:text-white">{FormatedDates(item?.createdOn)}</span>
                          <span className={`${styles.cardTime} dark:text-[#6B7280]`}>
                            {formattedTime}
                          </span>
                        </div>
                        <div className="flex flex-col items-end">
                          <Button
                            variant="ghost"
                            size="sm"
                            onClick={() => {
                              setData(item);
                              setIsOpen(true);
                            }}
                            title="View details"
                            className="p-4 h-auto mb-4"
                          >
                            <Eye size={16} />
                          </Button>
                          <MethodBadges methods={item?.Type} />
                        </div>
                      </div>

                      <div className={styles.cardBody}>
                        <p className={`${styles.cardSubject} dark:text-white`}>
                          {item.subject || "-"}
                        </p>
                        <p className={`${styles.cardMessage} dark:text-[#6B7280]`}>
                          {item?.Message?.length > 30
                            ? item.Message.substring(0, 30) + "..."
                            : item?.Message}
                        </p>
                      </div>

                      <div className={styles.cardRecipient}>
                        <span className={`${styles.cardRecipientLabel} dark:text-white`}>
                          {recipientLabel}
                        </span>
                        <span
                          className={styles.cardRecipientCount}
                          onClick={() => {
                            setOpenDialog(true);
                            setNames(recipientData);
                          }}
                        >
                          ({recipientCount})
                        </span>
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </Container>

      {/* {isOpen && (
        <NotificationDetails open={isOpen} onClose={handleClose} item={data} />
      )} */}
      <Dialog open={isOpen} onOpenChange={setIsOpen}>
        {data && (
          <NotificationDetails
            notification={data}
            onClose={() => setIsOpen(false)}
          />
        )}
      </Dialog>

      <Dialog open={openDialog} onOpenChange={setOpenDialog}>
        <DialogContent className="sm:max-w-md">
          <DialogHeader>
            <DialogTitle className="text-xl dark:text-white">Recipients</DialogTitle>
          </DialogHeader>

          <div className="py-4">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-h-[60vh] overflow-y-auto">
              {names?.map((name, index) => (
                <div
                  key={index}
                  className="flex items-center p-8 bg-slate-50 rounded-md dark:bg-gray-800"
                >
                  <User
                    size={16}
                    className="mr-8 text-slate-500 flex-shrink-0"
                  />
                  <span className="text-sm break-words dark:text-white">{name?.name}</span>
                </div>
              ))}
            </div>

            {names?.length === 0 && (
              <div className="text-center py-8 text-gray-500">
                No recipients found
              </div>
            )}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default Notification;
